'use client'
import { type FC, type ReactElement, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

const accentuateText = (text: ReactNode[]): ReactElement => <span>{text}</span>

const accentuateTextHighlight = (text: ReactNode[]): ReactElement => (
  <p className="mb-3.5">{text}</p>
)

export const ProductSearchResultInfoDialog: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => (
  <Dialog onClose={onClose} open={isOpen}>
    <DialogTitle onClose={onClose}>
      <FormattedMessage id="searchResults.label.infoHeader" />
    </DialogTitle>
    <DialogContent className="block">
      <FormattedMessage
        id="searchResults.label.info"
        values={{
          accentuate: accentuateText,
          accentuateHighlight: accentuateTextHighlight,
        }}
      />
    </DialogContent>
  </Dialog>
)
